import { render, staticRenderFns } from "./SwipingCards.vue?vue&type=template&id=d103fa96"
import script from "./SwipingCards.vue?vue&type=script&lang=js"
export * from "./SwipingCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports